import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Fragment, useEffect, useState } from 'react';
const noop = () => { };
const Styles = labelStyles('VisuallyHidden', {
    root: css `
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  `,
});
export const VisuallyHidden = (props) => {
    const [forceShow, setForceShow] = useState(false);
    useEffect(() => {
        if (process.env.NODE_ENV !== 'production') {
            const handleKeyDown = (event) => {
                if (event.key === 'Alt') {
                    setForceShow(true);
                }
            };
            const handleKeyUp = () => {
                setForceShow(false);
            };
            window.addEventListener('keydown', handleKeyDown, { capture: true });
            window.addEventListener('keyup', handleKeyUp, { capture: true });
            return () => {
                window.removeEventListener('keydown', handleKeyDown, { capture: true });
                window.removeEventListener('keydown', handleKeyUp, { capture: true });
            };
        }
        else {
            return noop;
        }
    }, []);
    if (forceShow) {
        return isolateComponent(Fragment, null, props.children);
    }
    return (isolateComponent("span", { css: Styles.root, "data-testid": "visually-hidden" }, props.children));
};
//# sourceMappingURL=VisuallyHidden.js.map
// @zapier/design-system@6.14.1 (10126c41d)
